import { gql } from '@apollo/client';

export const GET_ALL_PORTFOLIOS_BY_GENDERS = gql`
  query Query {
    getReportByGenders
  }
`;

export const GET_ALL_PORTFOLIOS_BY_ECONOMIC_ACT = gql`
  query Query {
    getReportByEconomyActivities
  }
`;

export const GET_ALL_PORTFOLIOS_BY_CITIES = gql`
  query Query {
    getReportByCityOfResidence
  }
`;

export const GET_ALL_PORTFOLIOS_BY_CAPITAL_PER_YEAR = gql`
  query Query {
    getReportCapitalPerYear
  }
`;

export const GET_ALL_PORTFOLIOS_BY_CREDITS_PER_YEAR = gql`
  query Query {
    getReportCreditsPerYear
  }
`;

export const GET_ALL_PORTFOLIOS_BY_COMPANIES = gql`
  query Query {
    getReportByCompanies
  }
`;

export const GET_ALL_PORTFOLIOS_BY_AGE_MONTHS_CREDITS = gql`
  query Query {
    getReportAvgMonthsCredits
  }
`;

export const CREDIT_PHASES_SUMMARY = gql`
  query GetCreditPhasesSummary($state: [Int]) {
    getCreditPhasesSummary(state: $state) {
      cpName
      count
      totalValCre
      pId
    }
  }
`;

export const SUM_VALUES = gql`
  query GetSumValCreByState {
    getSumValCreByState {
      totalValCre
      totalIcAmount
      difference
      percentage
    }
  }
`;

export const LAWYERS_CREDIT_SUMMARY = gql`
  query GetLawyersCreditSummary($state: [Int]) {
    getLawyersCreditSummary(state: $state) {
      sId
      lawyer
      companies
      creditLines
      cpcCompanyId
      totalCreditValue
    }
  }
`;
